import barba from '@barba/core';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";



function workItems()
{
    const workItems = document.querySelectorAll('.workList__item');

    if (workItems.length > 0)
    {
        [...workItems].forEach((element, index) => {
            const workItem__imageElement = element.querySelector('.workList__item-image, .workList__item-video');
            const workItem__titleElement = element.querySelector('.workList__item-title');
            const workItem__subTitleElement = element.querySelector('.workList__item-subTitle');
            const workItem__servicesElements = element.querySelectorAll('.workList__item-services li');
            
            const workItemTimeline = gsap.timeline();
            
            workItemTimeline.set(workItem__imageElement, { scale: 0.8, opacity: 0 });
            workItemTimeline.set(workItem__titleElement, { opacity: 0 });
            workItemTimeline.set(workItem__subTitleElement, { opacity: 0 });
            workItemTimeline.set(workItem__servicesElements, { opacity: 0, y: 25 });
            
            ScrollTrigger.create({
                trigger: element,
                start: "top 70%",
                onEnter: () => {
                    workItemTimeline.to(workItem__imageElement, { scale: 1, opacity: 1, duration: 0.5, delay: 0.2 });
                    workItemTimeline.to(workItem__titleElement, { opacity: 1, duration: 0.4, delay: 0.2 }, "-=0.5");
                    workItemTimeline.to(workItem__subTitleElement, { opacity: 1, duration: 0.4, delay: 0.2 }, "-=0.5");
                    workItemTimeline.to(workItem__servicesElements, { opacity: 1, y: 0, duration: 0.4, delay: 0.2, stagger:0.05 }, "-=0.5");
                }
            });
        });
    }
}


barba.hooks.enter((data) => {

    workItems();

});


workItems();